export default "__VITE_ASSET__3jcqdScT__"